<script>
import isNaN from 'lodash/isNaN';
import isUndefined from 'lodash/isUndefined';
import { mapState, mapGetters } from 'vuex';

export default {
  props: {
    page: String,
  },
  data: () => ({
    isUndefined,
  }),
  computed: {
    ...mapState({
      processing: state => state.processing,
      maxPages: state => state.home.maxPages,
    }),
    ...mapGetters(['homePages']),
  },
  methods: {
    goToPage(page) {
      if (isNaN(page) || page < 1) {
        page = 1;
      } else if (page > this.maxPages) {
        page = this.maxPages;
      }

      if (this.page != page && !this.processing) {
        this.$store.dispatch('getCampaigns', { page });
      }
    },
  },
};
</script>

<template lang='pug'>
.flex.justify-center.text-xl.items-center.mt-5.px-1_5.md_px-0.mb-4.pagination(v-if='homePages.length')
  .select-none.mr-3.cursor-pointer.hover_underline.whitespace-no-wrap(
    tabindex='0',
    :class='{ "opacity-75 pointer-events-none": page == 1 }',
    @click='goToPage(page - 1)',
    @keyup.enter='goToPage(page - 1)',
  )
    svg.inline.align-middle.mr-_5(xmlns='http://www.w3.org/2000/svg', width='8', height='13', viewBox='0 0 8 13')
      path.stroke-current(fill='none', stroke-linecap='round', stroke-linejoin='round', stroke-miterlimit='50', d='M7 1v0L1 6.5v0L7 12v0')
    span.align-middle Prev
  .select-none.h-2_75.w-2_75.flex.items-center.justify-center.cursor-pointer.hover_underline(
    v-for='pageNumber in homePages',
    tabindex='0',
    :class='{ "bg-brand text-white hover_no-underline": page == pageNumber || (pageNumber === 1 && isUndefined(page)) }',
    @click='goToPage(pageNumber)',
    @keyup.enter='goToPage(pageNumber)',
  ) {{pageNumber}}
  .select-none.ml-3.cursor-pointer.hover_underline.whitespace-no-wrap(
    tabindex='0',
    :class='{ "opacity-75 pointer-events-none": page == maxPages }',
    @click='goToPage(parseInt(page) + 1)',
    @keyup.enter='goToPage(parseInt(page) + 1)',
  )
    span.align-middle Next
    svg.inline.align-middle.ml-_5(xmlns='http://www.w3.org/2000/svg', width='8', height='13', viewBox='0 0 8 13')
      path.stroke-current(fill='none', stroke='#595959', stroke-linecap='round', stroke-linejoin='round', stroke-miterlimit='50', d='M1 1v0l6 5.5v0L1 12v0')
</template>

<style>
@import '~import/index';
</style>